import DescriptionBox from './DescriptionBox.component';
export default DescriptionBox;